import { SVGProps } from 'react';
import { ReactComponent } from 'icons/dollar.svg';

type Props = SVGProps<SVGSVGElement>;

/**
 * @deprecated Move to storybook instead
 */
export const DollarIcon = (props: Props) => {
  return <ReactComponent {...props} />;
};
